module.exports = {"svg":{"$":{"t":"1541498227933","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"1969","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M1024 563.2H195.1232l388.5056 388.608-71.68 71.68L0.6656 512 511.9488 0.512l71.68 71.68L195.1232 460.8H1024v102.4z","fill":"","p-id":"1970"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/assets/svg/to-left.svg
// module id = qwUb
// module chunks = 2